@if (suggestions().categories.results.length === 0 && suggestions().deals.results.length === 0 && suggestions().stores.results.length === 0 && suggestions().users.results.length === 0) {
  <div
    class="box theme-border-radius-10 theme-bg theme-top-search theme-text"
    [class.mobile]="mobile()"
    >
    <div class="box_inner">
      <!-- Sin texto escrito (31/10/2026, «esto hay que mejorarlo»): las recientes como píldoras
           que buscan otra vez, cada una con su ✕, y lo más buscado en cuadrícula de dos columnas. -->
      @if (recentSearches() && recentSearches().length > 0) {
        <div class="section recientes">
          <div class="header theme-text theme-top-search-title">
            <span>Búsquedas recientes</span>
            <button type="button" class="borrar_todo header_action" (click)="deleteHistory($event)">Borrar todo</button>
          </div>
          <div class="pildoras">
            @for (recent of recentSearches(); track recent.name) {
              <span class="pildora">
                <a class="invisible" [href]="'/results/?search=' + encodeUrl(recent.name)" (click)="closeBox.emit()" appGoToUrl>
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>
                  {{ recent.name }}
                </a>
                <button type="button" class="quitar" [attr.aria-label]="'Quitar «' + recent.name + '» del historial'" (click)="deleteRow($event, recent.name)">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>
                </button>
              </span>
            }
          </div>
        </div>
      }

      <div class="section tendencias">
        <div class="header theme-text theme-top-search-title">
          <span>Lo más buscado</span>
          <a href="/categorias/" class="invisible theme-text theme-primary header_action" (click)="closeBox.emit()" appGoToUrl>Ver categorías</a>
        </div>

        <div class="rejilla">
          @if (topSearch() && topSearch().length > 0) {
            @for (search of topSearch(); track search.slug) {
              <a class="tendencia invisible" [href]="search.slug | urlEtiqueta" (click)="closeBox.emit()" appGoToUrl>
                <span class="miniatura" aria-hidden="true">
                  @if (search.image_url) {
                    <img [src]="miniaturaSrc(search.image_url)" [attr.srcset]="miniaturaSrcset(search.image_url)" alt="" width="40" height="40" loading="lazy" onError="this.remove()">
                  } @else {
                    {{ (search.name || '?').charAt(0).toUpperCase() }}
                  }
                </span>
                <span class="nombre">{{ search.name }}</span>
              </a>
            }
          } @else {
            @for (i of [1, 2, 3, 4, 5, 6]; track i) {
              <span class="tendencia esqueleto" aria-hidden="true"></span>
            }
          }
        </div>
      </div>
  </div>
</div>
}

@if (suggestions().categories.results.length > 0 || suggestions().deals.results.length > 0 || suggestions().stores.results.length > 0 || suggestions().users.results.length > 0) {
<div
 
  class="box theme-border-radius-10 theme-bg theme-top-search theme-text"
  [class.mobile]="mobile()"
>
  <div class="box_inner">
    @if (suggestions().categories.results.length > 0) {
<div class="section category_search">
      <div class="header theme-text theme-top-search-title">
        <span>Categorías</span>
        <a href="/categorias/" class="invisible theme-text theme-primary header_action" (click)="closeBox.emit()" appGoToUrl>Ver más</a>
      </div>
      @for (search of suggestions().categories.results; track search; let index = $index) {
<a class="section_elem invisible" [href]="search.slug | urlEtiqueta" (click)="closeBox.emit()" appGoToUrl>
        <div class="section_image background_white">
          <img
            [src]="search.image_url || '/assets/images/logo_quad.png'"
                  [srcset]="search.image_url || '/assets/images/logo_quad.png'"
                  [alt]="search.name"
                  [title]="search.name"
                  onError="this.src='/assets/images/logo_quad.png'; this.srcset='/assets/images/logo_quad.png'"
                  appLazyload
                  >
              </div>
              <div class="section_info">
                <div class="title" [innerHTML]="search.nameHTML | safeHtml"></div>
                <div class="search_data theme-text theme-top-search-title">
                  <div class="data">
                    <svg appIcon src="/assets/icons/new_design/discount_tag.svg"></svg> <span>{{ search.total }} chollos</span>
                  </div>
                </div>
              </div>
            </a>
          }
        </div>
      }
      @if (suggestions().deals.results.length > 0) {
        <div class="section chollos_search">
          <div class="header theme-text theme-top-search-title">
            <span>Chollos</span>
        <a [href]="'/results/?search=' + encodeUrl(searchTerm())" class="invisible theme-text theme-primary header_action" (click)="closeBox.emit()" appGoToUrl>Ver todos los chollos</a>
      </div>
      @for (search of suggestions().deals.results; track search) {
<a class="section_elem invisible" [href]="search.slug | urlEtiqueta" (click)="closeBox.emit()" appGoToUrl>
        <div class="section_image background_white theme-border-color theme-chollo-user">
          <img [src]="search.image_url || '/assets/images/logo_quad.png'" [srcset]="search.image_url || '/assets/images/logo_quad.png'" [alt]="search.name" [title]="search.name" onError="this.src='/assets/images/logo_quad.png'; this.srcset='/assets/images/logo_quad.png'" appLazyload>
        </div>

        <div class="section_info">
          <div class="title">
            <span [innerHTML]="search.nameHTML | safeHtml"></span>
            <span class="chollo_price theme-text theme-primary"> {{ search.sale_price | customprice}}</span>
          </div>
  
          <div class="desc">
            <b>{{ search.kmh }}</b>
          </div>
        </div>
  
        <svg appIcon src="/assets/icons/new_design/chevron_right.svg" class="theme-text theme-primary"></svg>
      </a>
}
    </div>
}
  
    @if (suggestions().stores.results.length > 0) {
<div class="section">
      <div class="header theme-text theme-top-search-title">
        <span>Tiendas</span>
        <a href="/tiendas/" class="invisible theme-text theme-primary header_action" (click)="closeBox.emit()" appGoToUrl>Ver más</a>
      </div>
      @for (search of suggestions().stores.results; track search) {
<a class="section_elem invisible" [href]="search.slug | urlEtiqueta" (click)="closeBox.emit()" appGoToUrl>
        <div class="section_image background_white">
          <img [src]="search.image_url || '/assets/images/logo_quad.png'" [srcset]="search.image_url || '/assets/images/logo_quad.png'" [alt]="search.name" [title]="search.name" onError="this.src='/assets/images/logo_quad.png'; this.srcset='/assets/images/logo_quad.png'" appLazyload>
        </div>

        <div class="section_info">
          <div class="title" [innerHTML]="search.nameHTML | safeHtml"></div>
  
          <div class="search_data theme-text theme-top-search-title">
            <div class="data">
              <svg appIcon src="/assets/icons/new_design/discount_tag.svg"></svg> <span>{{ search.total }} chollos</span>
            </div>
          </div>
        </div>
      </a>
}
    </div>
}
  
    @if (suggestions().users.results.length > 0) {
<div class="section users_search">
      <div class="header theme-text theme-top-search-title">
        <span>Usuarios</span>
        <a href="/" class="invisible theme-text theme-primary header_action" (click)="closeBox.emit()" appGoToUrl>Ver más</a>
      </div>
      @for (search of suggestions().users.results; track search) {
<div class="section_elem" (click)="closeBox.emit()">
        <app-user [user]="search" [statitics]="false"></app-user>

        <div class="section_info">
          <a [href]="'/user/' + search.id + '/'" class="title invisible" appGoToUrl>
            <span [innerHTML]="search.usernameHTML | safeHtml"></span>
            <div class="search_data theme-text theme-top-search-title">
              <div class="data">
                <svg appIcon src="/assets/icons/new_design/discount_tag.svg"></svg> <span>{{ search.total_deals }} chollos</span>
              </div>
              <div class="data">
                <svg appIcon src="/assets/icons/new_design/chat.svg"></svg> <span>{{ search.total_comments }} comentarios</span>
              </div>
            </div>
          </a>
        </div>
      </div>
}
    </div>
}
  </div>
</div>
}